import { Injectable } from '@angular/core';
import { PermissionString } from '../classes/model/permissions';
import { BackendService } from './common/backend.service';
import { HttpErrorHandlerService } from './common/http-error-handler.service';
import { SessionService } from './common/session.service';

@Injectable({
  providedIn: 'root'
})
export class SelfPermissionsService {
  private readonly adminSelfPermissionApiUrlFragment:string = "/api/admin/permissions/self_permissions";

  constructor(
    private backendService:BackendService,
    private httpErrorHandlerService:HttpErrorHandlerService,
    private sessionService:SessionService
  ) { }

  public async updateSelfPermissions():Promise<void> {
    try {
      const response:{ permissions:Array<PermissionString> } = await this.backendService.callApi(this.adminSelfPermissionApiUrlFragment, "GET");
      this.sessionService.updatePermissions(response.permissions);
    } catch(error:any) {
      this.httpErrorHandlerService.handleError(error, "Hiba a saját jogosultságok lekérdezése közben.");
    }
  }

}
